__webpack_public_path__ = __root_url__ + 'templates/otu/assets/bundle/';

require('./myjs/menubar.js');
require('./myjs/react.js');
require('./myjs/shareButton.js');
require('./myjs/fundraiser.js');
require('./myjs/bootstrap.js');


